import { render, staticRenderFns } from "./PMTaskManagement.vue?vue&type=template&id=3bae9e6a&scoped=true"
import script from "./PMTaskManagement.vue?vue&type=script&lang=js"
export * from "./PMTaskManagement.vue?vue&type=script&lang=js"
import style0 from "./PMTaskManagement.vue?vue&type=style&index=0&id=3bae9e6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bae9e6a",
  null
  
)

export default component.exports